import { useMemo } from 'react';
import { Layer, LayerProps, type LineLayer } from 'react-map-gl';

// export const makeLineLayer
interface useLineLayerProps {}
export function useLineLayer(config: LineLayer) {
  return useMemo(() => <Layer {...config} />, [config]);
}
